import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Unsubscribe from "./pages/Unsubscribe";
import Privacy from "./pages/Privacy";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import Terms from "./pages/Terms";

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="min-h-screen bg-gradient-to-br from-[#1e1b4b] via-[#312e81] via-[#4c1d95] to-[#581c87] text-white relative overflow-hidden room-wall">
                {/* Cosmic nebula overlays */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 via-pink-500/20 to-blue-600/20 animate-pulse"></div>
                <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/10 via-transparent to-cyan-400/10"></div>
                
                {/* Floating joyful space emojis */}
                <div className="emoji-particle" style={{ top: '10%', left: '5%', animationDelay: '0s' }}>🎮</div>
                <div className="emoji-particle" style={{ top: '20%', right: '10%', animationDelay: '1s' }}>✨</div>
                <div className="emoji-particle" style={{ top: '60%', left: '8%', animationDelay: '2s' }}>🎯</div>
                <div className="emoji-particle" style={{ top: '40%', right: '5%', animationDelay: '1.5s' }}>🌟</div>
                <div className="emoji-particle" style={{ top: '80%', left: '15%', animationDelay: '0.5s' }}>🎨</div>
                <div className="emoji-particle" style={{ top: '30%', right: '15%', animationDelay: '2.5s' }}>🚀</div>
                <div className="emoji-particle" style={{ top: '15%', left: '50%', animationDelay: '1.2s' }}>💫</div>
                <div className="emoji-particle" style={{ top: '70%', right: '20%', animationDelay: '0.8s' }}>🌌</div>
                
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/game/:id" element={<GameDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}


export default App;
